import React from "react";
import { AutoTable, Modal, Button } from "@weezevent/nacre";
import useSortingTableWithSortingData from "../../hooks/useSortingTableWithSortingData";
import useChecklistsInfo from "../../hooks/useChecklistsInfo";
import { LoaderLine } from "../../../../../components/ui/loader";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

const ChecklistExportModal = ({ onClose = () => {}, open, checkListIds }) => {
	const { t } = useTranslation();
	const { getCheckLists } = useChecklistsInfo();

	const { isLoading, data } = useQuery(
		["check-lists-info", checkListIds],
		async () => {
			const checkListsInfo = await getCheckLists(checkListIds);

			return checkListIds.map((v, i) => ({
				id: v,
				checklistName: checkListsInfo[i].name,
				color: checkListsInfo[i].color
			}));
		}
	);

	const columns = React.useMemo(
		() => [
			{
				key: "checklistName",
				label: t(
					"access.checkpoint.exportTab.seeMoreModal.checklistNameColumn"
				),
				// eslint-disable-next-line
				render: ({ checklistName, color }) => (
					<>
						<Icon
							name="circle"
							size="large"
							style={{
								color
							}}
						/>
						{checklistName}
					</>
				)
			}
		],
		[t]
	);

	const sortedTable = useSortingTableWithSortingData({
		columns,
		data: data ?? [],
		sortingKeys: ["checklistName"],
		sortingDefaults: {
			defaultSortingKey: "checklistName",
			defaultSortingDirection: "ASC"
		}
	});

	return (
		<Modal
			title={t("access.checkpoint.exportTab.seeMoreModal.title")}
			onClose={onClose}
			open={open}
			cancelButton={
				<Button
					style={{ marginRight: "8px" }}
					label={t("access.checkpoint.exportTab.seeMoreModal.close")}
					onClick={onClose}
				/>
			}
		>
			{isLoading && (
				<div style={{ height: "50px" }}>
					<LoaderLine />
				</div>
			)}
			{!isLoading && (
				<AutoTable
					pk="id"
					useNew
					columns={sortedTable.columns}
					objects={sortedTable.data}
					onClickSorting={sortedTable.toggleSorting}
				/>
			)}
		</Modal>
	);
};

ChecklistExportModal.propTypes = {
	// eslint-disable-next-line react/require-default-props
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	checkListIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	downloadLink: PropTypes.string
};

export default ChecklistExportModal;
